import { FlowVersionStatus } from "src/clients/flow-api";
import { useCapabilities } from "src/hooks/useCapabilities";
import { flowFolderScope } from "src/hooks/useCapabilities/flowFolderScope";
import { useHasSimulation } from "src/hooks/useHasSimulation";
import { useAuthoringContext } from "src/router/routerContextHooks";

/**
 * @returns whether the current version can be edited by checking permissions and version status.
 */
export const useCanAuthoringEditFlowVersion = () => {
  const { flowVersions } = useCapabilities();
  const { flow, version, isRevision } = useAuthoringContext();
  const hasSimulation = useHasSimulation();
  return (
    flowVersions.canEdit(flowFolderScope(flow)) &&
    version.status !== FlowVersionStatus.PUBLISHED &&
    version.status !== FlowVersionStatus.ARCHIVED &&
    !hasSimulation &&
    !isRevision
  );
};
